<template>
  <div>
    <GlobalInfoBar title="贵州联通导入" />
    <GlobalChunk icon="search" title="筛选查询" :padding="[20, 20, 20, 20]">
      <GlobalForm :form-item-list="formItemList" :inline="true" :labelWidth="80" round @handleConfirm="handleConfirm"
        confirmBtnName="查询">
        <!-- <div slot="AddSlot">
          <el-button type="primary" size="mini" @click="tableExport"
            >数据导出</el-button
          >
        </div> -->
      </GlobalForm>
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="page" :total="total"
        @handleCurrentChange="handleCurrentChange">

      </GlobalTable>
    </GlobalChunk>
  </div>
</template>

<script>
import {
  batchList,
  stockDownload,
} from "@/utils/request";
export default {
  name: "index",
  data() {
    return {
      limit: 10,
      page: 1,
      total: 0,
      formItemList: [
        {
          key: "imei",
          type: "input",
          labelName: "串码:",
          placeholder: "请输入串码查询",
        },
        {
          key: "name",
          type: "input",
          labelName: "投保人:",
          placeholder: "请输入投保人查询",
        },
        {
          key: "phone",
          type: "input",
          labelName: "被保人电话:",
          placeholder: "请输入被保人电话查询",
          labelWidth: '180'
        },
        {
          key: "entryTime",
          type: "daterange",
          labelName: "入库时间:",
          valueFormat: "timestamp",
        },
      ],
      tableColumns: [
        { label: "投保人", prop: "applicantName" },
        { label: "投保人联系手机", prop: "mobileTelephone" },
        { label: "被保人", prop: "InsurantName2" },
        { label: "被保人手机", prop: "mobileTelephone2" },
        { label: "地市销售机构", prop: "address2" },
        { label: "串码", prop: "imei" },
        { label: "品牌", prop: "deviceBrand" },
        { label: "机型", prop: "deviceModel" },
        { label: "内存", prop: "deviceRam" },
        { label: "保费", prop: "totalInsuredAmount" },
        { label: "添加时间", prop: "addTime" },
      ],
      tableData: [],
      searchData: "",
      beg_time: "",
      end_time: "",
      fileList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const { imei, name, phone } = this.searchData
      batchList({
        page: this.page,
        limit: 10,
        imei,
        name,
        phone,
        beg_time: this.beg_time,
        end_time: this.end_time,

      }).then((res) => {
        this.tableData = res.data || [];
        this.total = res.count;
      });
    },
    handleConfirm(data) {
      console.log(`%c data`, "color:red", data);
      this.searchData = data;
      if (data.entryTime === null) {
        (this.beg_time = ""), (this.end_time = "");
      } else {
        this.beg_time = (data.entryTime && data.entryTime[0]) || "";
        this.end_time = (data.entryTime && data.entryTime[1]) || "";
      }
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getList();
    },
    tableExport() {
      stockDownload({
        claims_sn: this.claims_sn,
        beg_time: this.beg_time,
        end_time: this.end_time,
      }).then((res) => {
        if (res.type === "application/json") {
          let fileReader = new FileReader();
          fileReader.readAsText(res);
          fileReader.addEventListener("loadend", (e) => {
            let err = JSON.parse(fileReader.result || "");
            this.$message.error(err.msg || "导出失败");
          });
        } else {
          var blob = new Blob([res], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = `入库记录_${+new Date()}.xls`; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        }
      });
    },
  },
};
</script>

<style scoped></style>
